export default __webpack_public_path__ + "static/licenseIcon-e7fd76bb54a993fb852bd2b25e59136e.svg";